import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialogRef } from '@angular/material/dialog';

import { EnvironmentData, SessionService } from 'app/core';

import { SidenavService } from '@libs/layouts/side-nav/services';

import { Account, Environment } from '@app/common/interfaces';


@Component({
  templateUrl: './environment-switch.component.html',
  styleUrls: ['./environment-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentSwitchComponent implements OnInit {

  public environments: Environment[] = [];
  public projectLimit = 5;
  public account: Account = null;

  constructor(
    private _dialogRef: MatDialogRef<EnvironmentSwitchComponent>,
    private _environmentData: EnvironmentData,
    private _sessionService: SessionService,
    private _router: Router,
    private _sidenavService: SidenavService,
    private _cdRef: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this._environmentData.gets()
      .subscribe((environments) => {
        this.environments = environments;
        this._cdRef.markForCheck();
      });

    this.account = this._sessionService.account();
  }

  public switch(environment): void {
    this._environmentData.switch(this.account.id, environment.id)
      .subscribe(
        (response) => {
          this._sidenavService.hide();
          this._sessionService.environment(response);
          this._dialogRef.close(response);
          this._router.navigate(['blank']).then(() => {
            this._router.navigateByUrl('/dashboard');
          });
        });
  }

  public close(): void {
    this._dialogRef.close();
  }
}
